// extracted by mini-css-extract-plugin
export var bubble = "_3n-0";
export var container = "_3n-3";
export var contrastBorder = "_3n-4";
export var greyOut = "_3n-2";
export var initialsWrapper = "_3n-1";
export var large = "_3n-9";
export var medium = "_3n-8";
export var mediumSmall = "_3n-7";
export var mediumSmallMedium = "_3n-c";
export var micro = "_3n-5";
export var small = "_3n-6";
export var tiny = "_3n-b";
export var xTiny = "_3n-a";